import { GetStaticProps } from "next";
import { getAllPosts, type PostMeta } from "~/lib/mdx";
import {
  buildDefaultSolutionsSections,
  createSolutionsPage,
} from "~/components/solutions/solutionsPageFactory";
import InfoLinks from "~/components/InfoLinks";
import { SolutionsForHomeownersContent as content } from "~/content/dla-wlascicieli-domow/content.pl";

const selectedId = [121, 122, 123, 124, 125];

const sections = buildDefaultSolutionsSections(content, <InfoLinks />);

export default createSolutionsPage({
  content,
  faqSelectedIds: selectedId,
  sections,
});

export const getStaticProps: GetStaticProps<{ recentPosts: PostMeta[] }> = async () => {
  const recentPosts = getAllPosts().slice(0, 3);
  return { props: { recentPosts } };
};
